import { render } from "./CookieComponent.vue?vue&type=template&id=17026831&scoped=true"
import script from "./CookieComponent.vue?vue&type=script&lang=js"
export * from "./CookieComponent.vue?vue&type=script&lang=js"

import "./CookieComponent.vue?vue&type=style&index=0&id=17026831&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17026831"]])

export default __exports__